import axiosInstance from './axiosInstance';

const updateActiveIndexerById = ({ id, active }) =>
  axiosInstance.patch(`/internal/admin/config/indexers/${id}`, {
    active,
  });

export default updateActiveIndexerById;
